import { api } from "../config/api";

export const submitEvaluation = async (jobApplicationId, rating, comment) => {
  const response = await api.post(
    `/Evaluations/${jobApplicationId}`,
    { rating, comment }
  );

  return response.data;
};

export const getUserEvaluations = async (userId) => {
  const response = await api.get(`/Evaluations/user/${userId}`);
  return response.data;
};

export const getEvaluationSummary = async (userId) => {
  const response = await api.get(`/Evaluations/user/${userId}/summary`);
  return response.data;
};